// ===================== Mini Cart + Add to Cart (single-call, with cart count sync) =====================
(function() {
  const miniCart = document.getElementById('mini-cart');
  if (!miniCart) return;

  const openDrawer = () => miniCart.classList.add('open');
  const closeDrawer = () => miniCart.classList.remove('open');

  // Optional external open triggers
  document.querySelectorAll('#open-mini-cart,[data-open-mini-cart]').forEach(el => {
    el.addEventListener('click', e => { e.preventDefault(); openDrawer(); });
  });

  // Close by overlay / close button / Esc
  miniCart.addEventListener('click', e => {
    if (e.target.matches('[data-close-mini-cart]')) closeDrawer();
  });
  document.addEventListener('keydown', e => {
    if (e.key === 'Escape') closeDrawer();
  });

  // Fetch & replace the inner content of the drawer
  async function refreshMiniCart() {
    const res = await fetch('/cart?view=mini-cart', { credentials: 'same-origin' });
    const html = await res.text();
    const doc = new DOMParser().parseFromString(html, 'text/html');
    const fresh = doc.querySelector('.mini-cart-content');
    if (fresh) {
      miniCart.querySelector('.mini-cart-content').innerHTML = fresh.innerHTML;
    }
  }

  // ---------------- Add to cart via captured click (prevents double adds) ----------------
  let adding = false;

  document.addEventListener('click', async function(e) {
    // Find an Add-to-Cart button inside a product form
    const btn = e.target.closest('form[action*="/cart/add"] [type="submit"], [data-add-to-cart]');
    if (!btn) return;

    const form = btn.closest('form[action*="/cart/add"]');
    if (!form) return;

    // Stop native submit and other theme click handlers (this listener runs in capture phase)
    e.preventDefault();
    e.stopPropagation();
    e.stopImmediatePropagation();

    if (adding || form.dataset.processing === '1') return;
    adding = true;
    form.dataset.processing = '1';

    // UX: disable the button to avoid double taps
    const wasDisabled = btn.disabled;
    btn.disabled = true;

    try {
      const data = new FormData(form);
      const addRes = await fetch('/cart/add.js', {
        method: 'POST',
        body: data,
        headers: { 'Accept': 'application/json' },
        credentials: 'same-origin'
      });

      if (!addRes.ok) {
        const err = await addRes.json().catch(() => ({}));
        throw new Error(err.description || 'Could not add to cart.');
      }

      await refreshMiniCart();
      await syncCartCount();   // <-- update header badge
      openDrawer();
    } catch (err) {
      console.error('Add to cart error:', err);
      alert(err.message || 'Something went wrong adding to cart.');
    } finally {
      adding = false;
      delete form.dataset.processing;
      btn.disabled = wasDisabled;
    }
  }, true); // ← capture phase is the key

  // ---- Quantity & Remove inside drawer ----
  async function changeLineQty(lineKey, newQty) {
    const body = new URLSearchParams();
    body.set('id', lineKey);           // use item.key
    body.set('quantity', String(newQty));

    const res = await fetch('/cart/change.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
        'Accept': 'application/json'
      },
      body,
      credentials: 'same-origin'
    });
    if (!res.ok) {
      const err = await res.json().catch(() => ({}));
      throw new Error(err.description || 'Could not update quantity.');
    }
  }

  // Debounce helper for typing into qty input
  function debounce(fn, delay) {
    let t;
    return function(...args) {
      clearTimeout(t);
      t = setTimeout(() => fn.apply(this, args), delay);
    };
  }

  // Delegate clicks for + / − and remove
  miniCart.addEventListener('click', async (e) => {
    const li = e.target.closest('.mini-cart-item');
    if (!li) return;

    const key = li.getAttribute('data-line-key');
    const input = li.querySelector('[data-qty-input]');
    let current = parseInt(input?.value || '1', 10) || 1;

    // +
    if (e.target.matches('[data-qty="up"]') || e.target.closest('[data-qty="up"]')) {
      e.preventDefault();
      try {
        await changeLineQty(key, current + 1);
        await refreshMiniCart();
        await syncCartCount(); // <-- keep badge in sync
      } catch (err) {
        console.error(err); alert(err.message || 'Update failed.');
      }
      return;
    }
    // − (0 removes)
    if (e.target.matches('[data-qty="down"]') || e.target.closest('[data-qty="down"]')) {
      e.preventDefault();
      try {
        await changeLineQty(key, Math.max(0, current - 1));
        await refreshMiniCart();
        await syncCartCount();
      } catch (err) {
        console.error(err); alert(err.message || 'Update failed.');
      }
      return;
    }

    // Remove
    if (e.target.matches('[data-remove]')) {
      e.preventDefault();
      try {
        await changeLineQty(key, 0);
        await refreshMiniCart();
        await syncCartCount();
      } catch (err) {
        console.error(err); alert(err.message || 'Removal failed.');
      }
      return;
    }
  });

  // Delegate qty input typing with debounce
  const onQtyInput = debounce(async (inputEl) => {
    const li = inputEl.closest('.mini-cart-item');
    if (!li) return;
    const key = li.getAttribute('data-line-key');
    let val = parseInt(inputEl.value || '0', 10);
    if (isNaN(val) || val < 0) val = 0;

    try {
      await changeLineQty(key, val);
      await refreshMiniCart();
      await syncCartCount();
    } catch (err) {
      console.error(err);
      alert(err.message || 'Update failed.');
    }
  }, 500);

  miniCart.addEventListener('input', (e) => {
    if (e.target.matches('[data-qty-input]')) {
      onQtyInput(e.target);
    }
  });

  // Initialize badge once on load (in case cart already has items)
  syncCartCount();
})();

// ===================== Force checkout navigation (in case other theme JS blocks anchors) =====================
document.addEventListener('click', function (e) {
  const btn = e.target.closest('[data-checkout]');
  if (!btn) return;

  e.preventDefault();           // cancel any theme handlers
  e.stopPropagation();          // don't bubble to product/link handlers
  window.location.href = btn.getAttribute('href') || '/checkout';
});

// ===================== Drawer behavior (lock scroll, expose open/close) =====================
(function () {
  const drawer = document.getElementById('mini-cart');
  let scrollY = 0;

  function lockScroll() {
    // Save current scroll
    scrollY = window.scrollY || window.pageYOffset || 0;

    // Fix the body in place (prevents background scroll on iOS too)
    document.body.style.position = 'fixed';
    document.body.style.top = `-${scrollY}px`;
    document.body.style.left = '0';
    document.body.style.right = '0';
    document.body.style.width = '100%';

    // Optional, but helps some themes
    document.documentElement.classList.add('drawer-open');
    document.body.classList.add('drawer-open');
  }

  function unlockScroll() {
    // Restore styles
    document.body.style.position = '';
    document.body.style.top = '';
    document.body.style.left = '';
    document.body.style.right = '';
    document.body.style.width = '';

    document.documentElement.classList.remove('drawer-open');
    document.body.classList.remove('drawer-open');

    // Restore scroll
    window.scrollTo(0, scrollY || 0);
  }

  function openDrawer() {
    if (!drawer) return;
    // Ensure the drawer is the last element in <body> (wins stacking ties)
    if (drawer.parentElement !== document.body || document.body.lastElementChild !== drawer) {
      document.body.appendChild(drawer);
    }
    drawer.classList.add('open');
    lockScroll();
  }

  function closeDrawer() {
    if (!drawer) return;
    drawer.classList.remove('open');
    unlockScroll();
  }

  // Expose (if you need to call from elsewhere)
  window.openMiniCart = openDrawer;
  window.closeMiniCart = closeDrawer;

  // Overlay click + ESC close
  document.addEventListener('click', (e) => {
    if (e.target.matches('[data-close-mini-cart]')) {
      e.preventDefault();
      closeDrawer();
    }
  });
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape') closeDrawer();
  });

  // Prevent touch scroll on background when open (iOS fix)
  document.addEventListener(
    'touchmove',
    (e) => {
      if (!document.body.classList.contains('drawer-open')) return;
      if (!e.target.closest('.mini-cart-panel')) {
        e.preventDefault();
      }
    },
    { passive: false }
  );

  // Example: hook up any openers (keep your existing triggers too)
  document.addEventListener('click', (e) => {
    if (e.target.closest('[data-open-mini-cart], #open-mini-cart')) {
      e.preventDefault();
      openDrawer();
    }
  });
})();

// ===================== Cart Count Helpers (supports data- hooks + legacy fallback) =====================
function setCartCount(n) {
  // Preferred: data hooks (add these to your header if possible)
  document.querySelectorAll('[data-cart-count-badge]').forEach(el => {
    el.textContent = String(n);
    el.closest('.cart-count-bubble')?.classList.toggle('hidden', n <= 0);
  });
  document.querySelectorAll('[data-cart-count-text]').forEach(el => {
    el.textContent = String(n);
  });

  // Fallbacks for your current markup:
  // - the badge <div> inside #open-mini-cart
  const fallbackBadge = document.querySelector('#open-mini-cart > div');
  if (fallbackBadge) fallbackBadge.textContent = String(n);

  // - number inside parentheses in the .text-link
  const label = document.querySelector('#open-mini-cart .text-link');
  if (label) {
    const txt = label.textContent;
    if (/\(\s*\d+\s*\)/.test(txt)) {
      label.textContent = txt.replace(/\(\s*\d+\s*\)/, `(${n})`);
    } else {
      // if there wasn't a (n) before, append it
      label.textContent = `${txt.trim()} (${n})`;
    }
  }

  // Accessibility
  const headerCart = document.getElementById('open-mini-cart');
  if (headerCart) {
    headerCart.setAttribute('aria-live', 'polite');
    headerCart.setAttribute('aria-atomic', 'true');
  }

  // Let other scripts react if needed
  document.dispatchEvent(new CustomEvent('cart:count-updated', { detail: { count: n } }));
}

async function syncCartCount() {
  try {
    const res = await fetch('/cart.js', {
      credentials: 'same-origin',
      headers: { 'Accept': 'application/json' }
    });
    if (!res.ok) return;
    const cart = await res.json();
    setCartCount(cart.item_count || 0);
  } catch (e) {
    // swallow
  }
}
